import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { HtmlRendering } from '../../../components/ui/HtmlRendering/HtmlRendering';
import { ModuleWrapper } from '../../../components/ui/ModuleWrapper/ModuleWrapper';
import { httpService } from '../../../utils/httpService';

export const DynamicBanner = ({ url }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      let data = null;
      try {
        const response = await httpService().get(url, {
          readBody: (res) => res.text(),
          includeTracing: false,
        });
        data = response?.statusCode === 200 ? response.data : null;
      } catch {
        data = null;
      }
      setHtml(data);
    };
    fetchData();
  }, []);
  if (!html) return null;
  return (
    <ModuleWrapper>
      <HtmlRendering html={html} />
    </ModuleWrapper>
  );
};

DynamicBanner.propTypes = {
  url: PropTypes.string.isRequired,
};
